module.exports = __webpack_public_path__ + "static/media/events-icon-active-pen.26ca9594.png";